/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Defines available data types for fields. Each type can have specific
 * attributes assigned. Type attribute determines the form of the corresponding value
 * (see type-to-value mapping table in [`AnyValue`](#model-AnyValue).
 *
 */
export enum ConfigurationFieldType {
    AMOUNT = 'AMOUNT',
    ARRAY = 'ARRAY',
    BOOLEAN = 'BOOLEAN',
    COUNTRIES = 'COUNTRIES',
    DATE = 'DATE',
    DATE_RANGE = 'DATE_RANGE',
    FEES = 'FEES',
    HR_REFERENCE_NUMBER = 'HR_REFERENCE_NUMBER',
    INTEGER = 'INTEGER',
    LINKED_VALUES = 'LINKED_VALUES',
    MULTI_VALUES = 'MULTI_VALUES',
    RS_REFERENCE_NUMBER = 'RS_REFERENCE_NUMBER',
    TAX_POSITIONS = 'TAX_POSITIONS',
    TEXT = 'TEXT',
    TRANSFER_DATE = 'TRANSFER_DATE',
    TRANSFER_TIME = 'TRANSFER_TIME',
    VALUES = 'VALUES',
}
